var _defs, _rect, _rect2, _rect3, _path, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHScrollLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 221.89 170.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-3);}.cls-3{fill:url(#linear-gradient-4);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -8.05,
    y1: 138.05,
    x2: 64.05,
    y2: 65.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfdbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dcebfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 56.45,
    y1: 149.55,
    x2: 151.55,
    y2: 54.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed4899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa923c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 146.45,
    y1: 141.55,
    x2: 225.55,
    y2: 62.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa923c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbcd15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 7.5,
    y1: 21.5,
    x2: 213.5,
    y2: 21.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eff1f1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b7e9e3",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#87e2d7",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5ddccd",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3bd7c5",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#21d3bf",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0ed1ba",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#03cfb7",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00cfb7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 145.85,
    y1: 38.65,
    x2: 180.15,
    y2: 4.35,
    gradientTransform: "translate(184.5 -141.5) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38bdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#34d399"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9,
    y: 44,
    width: 38,
    height: 116,
    rx: 8.35,
    ry: 8.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 62,
    y: 44,
    width: 84,
    height: 116,
    rx: 8.35,
    ry: 8.35,
    transform: "translate(-11.18 12.82) rotate(-6.7)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160,
    y: 44,
    width: 52,
    height: 116,
    rx: 8.35,
    ry: 8.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M206.54,12c3.02,0,5.46,2.44,5.46,5.46v8.08c0,3.02-2.44,5.46-5.46,5.46H14.46c-3.02,0-5.46-2.44-5.46-5.46v-8.08c0-3.02,2.44-5.46,5.46-5.46H206.54m0-1.5H14.46c-3.84,0-6.96,3.12-6.96,6.96v8.08c0,3.84,3.12,6.96,6.96,6.96H206.54c3.84,0,6.96-3.12,6.96-6.96v-8.08c0-3.84-3.12-6.96-6.96-6.96h0Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 153.5,
    y: -6.5,
    width: 19,
    height: 56,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(141.5 184.5) rotate(-90)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHScrollLogo);
export default __webpack_public_path__ + "static/media/h-scroll-logo.d19ce9ec60a6fa33c5d0d9b068a8c730.svg";
export { ForwardRef as ReactComponent };